<lib-product-feature-label
  *ngIf="hasMountedFramedPosters"
  [labelText]="'txt_mounted_framed_poster_available' | translate"
  [tooltipText]="'txt_mounted_framed_poster_available_tooltip' | translate"
></lib-product-feature-label>
<lib-product-feature-label
  *ngIf="hasEmbroidery"
  [labelText]="'txt_embroidery_available' | translate"
  [tooltipText]="'txt_embroidery_available_tooltip' | translate"
></lib-product-feature-label>
